// frontend/src/pages/reports/ReportsHub.jsx
// Landing page with report navigation — single tile, structured list layout.

import React from 'react';
import TabLink from '../../tabs/TabLink';
import { useTranslation } from 'react-i18next';
import { ICON, CaretRight } from '../../icons';
import { PageIcon } from '../../config/appPages';
import { REPORTS } from './reportsCatalogue';
import { getTitleKeyForPath } from '../../tabs/routeRegistry';
import Tile from '../../components/layout/Tile';
import '../../styles/pages.css';
import './ReportsHub.css';


function ReportsHub() {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <Tile title={t('nav.reports')}>
        <div className="reports-hub-list">
          {REPORTS.map((report, index) => (
            <TabLink
              key={report.key}
              to={report.path}
              className={`reports-hub-row ${index === REPORTS.length - 1 ? 'reports-hub-row-last' : ''}`}
            >
              <div
                className="reports-hub-icon"
                style={{ color: report.color, backgroundColor: report.bg }}
              >
                <PageIcon path={report.path} size={ICON.xl} weight="duotone" />
              </div>
              <div className="reports-hub-text">
                <span className="reports-hub-row-title">
                  {t(getTitleKeyForPath(report.path))}
                </span>
                <span className="reports-hub-row-question">
                  {t(`reports.hub.${report.key}.question`)}
                </span>
              </div>
              <CaretRight size={ICON.md} className="reports-hub-chevron" />
            </TabLink>
          ))}
        </div>
      </Tile>
    </div>
  );
}

export default ReportsHub;
